/**
 * The media deck's arithmetic, kept out of the viewer component so it can be unit-tested: the
 * component's own import graph reaches `FileAccessUtils`, which closes an import cycle back through
 * the thunks and throws under Jest (`_fetch_utils.default is not a constructor`) — a pre-existing
 * knot this file simply stays out of.
 */

/**
 * Where a step through the deck lands. Clamped rather than wrapped, so the last item does not loop
 * back to the first — the arrow that would not move anywhere is hidden instead.
 */
export const stepMediaIndex = (index: number, delta: number, count: number): number => {
	if (count === 0) {
		return 0;
	}
	return Math.min(Math.max(index + delta, 0), count - 1);
};
